import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tab,
  Tabs,
  Typography,
} from '@material-ui/core';
import CreateModel from './CreateModel';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles, Theme } from '@material-ui/core/styles';
import CategoryTab from './CategoryTab';
import ManufacturersTab from './ManufacturersTab';
import HoldingProfilesTab from './HoldingProfilesTab';
import { useDispatch } from 'react-redux';
import { TabPanelProps } from '../interfaces/TabPanelProps';
import { clearEntityToEdit } from '../../../redux/actions/equipmentsActions';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
  tabs: {
    fontSize: 12,
  },
  divItems: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  appBar: {
    backgroundColor: theme.palette.appBarsColor.main,
  },
}));
function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  const dispatch: any = useDispatch();
  useEffect(() => {
    const onDestroy = () => {
      dispatch(clearEntityToEdit());
    };
    return onDestroy;
  }, []);
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}
const EquipmentCreateDialog = ({
  open,
  handleClose,
  handleRefreshOnCreate,
}) => {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const handleChange = (
    event: React.ChangeEvent<unknown>,
    newValue: number,
  ) => {
    setValue(newValue);
  };

  const { t } = useTranslation();

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={open}
      onClose={handleClose}
      aria-labelledby="max-width-dialog-title"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogContent>
        <DialogTitle id="alert-dialog-title">
          <div className={classes.divItems}>
            <Typography variant="h6">
              {t('equipment.updateEquipmentCatalog')}
            </Typography>
            <IconButton
              style={{ position: 'relative', left: 10, bottom: 10 }}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <AppBar position="static" color="primary" className={classes.appBar}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            textColor="inherit"
            variant="fullWidth"
            aria-label="full width tabs example"
            className={classes.tabs}
          >
            <Tab
              className={classes.tabs}
              label={t('equipment.model')}
              {...a11yProps(0)}
            />

            <Tab
              className={classes.tabs}
              label={t('equipment.category')}
              {...a11yProps(1)}
            />

            <Tab
              className={classes.tabs}
              label={t('equipment.manufacturer')}
              {...a11yProps(2)}
            />

            <Tab
              className={classes.tabs}
              label={t('equipment.holdingProfile')}
              {...a11yProps(3)}
            />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          {value === 0 && (
            <CreateModel
              handleClose={handleClose}
              handleRefreshOnCreate={handleRefreshOnCreate}
            />
          )}
        </TabPanel>
        <TabPanel value={value} index={1}>
          <CategoryTab />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ManufacturersTab />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <HoldingProfilesTab />
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
};

export default EquipmentCreateDialog;
